import React from 'react';

import Container from '@src/components/Shared/Container';
import NextImage from '@src/components/Shared/NextImage';
import SectionHeader from '@src/components/Shared/SectionHeader';

import { ImageTextTertiaryPropTypes } from './ImageTextTertiary.types';

const ImageTextTertiary: React.FC<ImageTextTertiaryPropTypes> = ({
  id,
  className,
  pretitle,
  title,
  titleClassName,
  imgURL,
  imgAlt = '',
  childrenElements,
  reversed = false,
  objectFit = 'cover',
  imgChildElements = null,
  background,
  aspectRatio = 16 / 9,
  width = 1600,

  // Passing additional Classes via Props for more flexibility
  imgFirstClassName = '',
  imgSecondClassName = '',
  textContainerClassName = '',
  sectionHeaderClassName = '',
}) => {
  return (
    <div id={id} className={background}>
      <Container className={`flex flex-col gap-[5.2rem] lg:flex-row ${className}`}>
        {imgURL && (
          <NextImage
            className={`lg:mb-[unset] lg:hidden ${imgFirstClassName}`}
            src={imgURL}
            alt={imgAlt}
            aspectRatio={aspectRatio}
            width={width}
            objectFit={objectFit}
          >
            {imgChildElements}
          </NextImage>
        )}

        {imgURL && (
          <NextImage
            className={`hidden lg:relative lg:block lg:w-[50%] ${reversed ? 'order-1' : ''} ${imgSecondClassName}`}
            src={imgURL}
            alt={imgAlt}
            objectFit={objectFit}
          >
            {imgChildElements}
          </NextImage>
        )}

        <div className={`lg:relative lg:z-20 lg:w-[50%] ${textContainerClassName}`}>
          <SectionHeader
            className={`lg:relative lg:z-5 lg:py-[10rem] ${sectionHeaderClassName}`}
            pretitle={pretitle}
            preTitleClassName='mb-[1.6rem]'
            title={title}
            titleClassName={`text-[2.8rem] leading-[3.2rem] mb-[1.8rem] lg:mb-[3.2rem] lg:text-[4.8rem] lg:leading-[5rem] lg:tracking-[-0.096rem] ${titleClassName}`}
            childrenClassName='relative'
            align='left'
          >
            {childrenElements}
          </SectionHeader>
        </div>
      </Container>
    </div>
  );
};

export default ImageTextTertiary;
